import { render, staticRenderFns } from "./BasePhoneListControls.vue?vue&type=template&id=63d4d852"
import script from "./BasePhoneListControls.vue?vue&type=script&lang=js"
export * from "./BasePhoneListControls.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneListControls.vue?vue&type=style&index=0&id=63d4d852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports